<template>
  <div :style=style>
    <b-card no-body class="border-0">
      <b-list-group>
        <b-list-group-item list-group-item-action class="pointer" v-for="item in listData" :key="item.retail_id"
                           @click="getIdFilter(item.retail_id)"
                           :active="item.retail_id === activeListItem">
          <strong>{{item.retail_name}}</strong> <br>
          <h6>Productos con quiebre {{item.stock_break_status}}</h6>
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>

<script>
  export default {
    name: '',
    props: ['activeItem', 'listData'],
    components: {},
    data () {
      return {
        activeListItem: 0
      }
    },
    created () {
      this.style = `height: ${this.vuexAvailableHeight}px; overflow: scroll; overflow-x:hidden;`
    },
    watch: {
      activeItem (id) {
        this.setItem(id)
      }
    },
    computed: {
      vuexAvailableHeight () {
        return this.$store.state.appAvailableHeight - 66
      }
    },
    methods: {
      getIdFilter (id) {
        this.activeListItem = id
        this.$store.commit('commit_genKeyKpiAnalysis_selectedRetail', id)
      },
      setItem (id) {
        this.activeListItem = id
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/expertoRetail/components/GeneralKeyKpiAnalysis/StockBreakRetailList.vue